var bookchaptersList = [
    {
        "year": "2015",
        "yearWork": [
            {
                "data": `M. Asif Naeem, “Online Processing of End-User Data in Real-Time Data Warehousing”, Improving Knowledge Discovery through the Integration of Data Mining Techniques, 2015.`,
                "pdflink": `https://doi.org/10.4018/978-1-4666-8513-0`
            },
        ]
    },
    {
        "year": "2012",
        "yearWork": [
            {
                "data": `M. Asif Naeem , Gillian Dobbie, and Gerald Weber, “Efficient processing of stream data over persistent data”, Big Data Computing, Taylor and Francis, 2012.`,
                "pdflink": `https://doi.org/10.1201/b16014`
            },
            {
                "data": `M. Asif Naeem , Gillian Dobbie, and Gerald Weber, “ Processing of Stream Data in a Real-Time Data Warehouse”, Big Data Management, Technologies, and Applications, IGI Global, 2012.`,
                "pdflink": `https://doi.org/10.4018/978-1-4666-4699-5.ch007`
            },
        ]
    },
]
export default bookchaptersList;